import React from "react";
import { RequireRole } from "../router/RequireRole";
import { PrivacyPage } from "./PrivacyPage";
import { PrivacyPolicyPage } from "./PrivacyPolicyPage";

/**
 * TASK-19 · Privacy routes (Ley 1581).
 *   /politica-privacidad        public static policy
 *   /:slug/app/privacidad       authenticated "Mis datos personales"
 */
const privacyRoutes = [
  { path: "/politica-privacidad", element: <PrivacyPolicyPage />, public: true },
  {
    path: "/:slug/app/privacidad",
    element: <RequireRole />,
    children: [{ index: true, element: <PrivacyPage /> }],
  },
];

export default privacyRoutes;
